import { SelectNoteMixin } from '@/scripts/Notes/NoteDetail/mixins/SelectNoteMixin';

export default {
  name: 'QuestionNoteContent',

  mixins: [SelectNoteMixin],

  props: {
    p_note: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    openNoteQuestion() {
      this.selectNote();
      this.$emit('open-note-question');
    },
  },
};
